import { isComingSoonImage, checkComingSoonImage, COMING_SOON_PLACEHOLDER } from '~/utils/comingSoonImages';

export const useComingSoonImage = (imageUrl: MaybeRef<string | null | undefined>) => {
  const url = ref<string>(COMING_SOON_PLACEHOLDER);
  const isComingSoon = ref(true);
  const isChecking = ref(false);

  let currentCheckId = 0;

  const checkImage = async () => {
    const checkId = ++currentCheckId;
    const rawUrl = toValue(imageUrl);

    if (!rawUrl) {
      url.value = COMING_SOON_PLACEHOLDER;
      isComingSoon.value = true;
      return;
    }

    const cachedResult = isComingSoonImage(rawUrl);
    if (cachedResult) {
      url.value = COMING_SOON_PLACEHOLDER;
      isComingSoon.value = true;
      return;
    }

    url.value = rawUrl;
    isComingSoon.value = false;
    isChecking.value = true;

    try {
      const result = await checkComingSoonImage(rawUrl);

      if (checkId !== currentCheckId) return;

      if (result) {
        url.value = COMING_SOON_PLACEHOLDER;
        isComingSoon.value = true;
      }
    } catch {
      // Keep showing the original image on error
    } finally {
      if (checkId === currentCheckId) {
        isChecking.value = false;
      }
    }
  };

  watch(
    () => toValue(imageUrl),
    () => {
      checkImage();
    },
    { immediate: true },
  );

  onUnmounted(() => {
    currentCheckId++;
  });

  return { url, isComingSoon, isChecking };
};
